import { prop } from 'ramda';
import React, { useEffect } from 'react';
import { Table, TABLE_VIEW } from 'js/components/common/Table';
import { componentService } from 'js/services/component.service';
import { withComponent } from 'js/components/hocs/withComponent';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as hooks from './hooks';
import { withDynamicReducer, useDynamicReducerSelector } from './store';

import * as style from './TermsAndConditionsHistory.scss';

export const TermsAndConditionsHistoryBare: React.FC = () => {
    const tableData = hooks.useTableData();
    const getHistory = hooks.useGetHistory();
    const translate = useComponentTranslations();
    const isLoading = useDynamicReducerSelector(prop('isLoading'));

    useEffect(() => {
        getHistory();
    }, [getHistory]);

    return (
        <Table
            classNames={style}
            isLoading={isLoading}
            tableData={tableData}
            tableRowView={TABLE_VIEW.TABLE}
            emptyTitle={translate('playtech.mobile.system.termsAndConditionsHistory.empty')}
        />
    );
};

export const TermsAndConditionsHistory = withComponent({
    isForLoggedIn: true
})(withDynamicReducer()(TermsAndConditionsHistoryBare));

componentService.registerWebContentComponents({ TermsAndConditionsHistory });
